/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
    mutation MncCreateThroughExcelMutation($file: File!) {
    MncCreateThroughExcel(file: $file) {
        id,
        createdAt,
        updatedAt,
        status,
        message
    }
  }
`
